<template>
    <MainContentSearchable title="Listado de etiquetas" id="etiquetas" v-model="filters" :meta="loading ? {} : etiquetas.meta" @updated="debouncedGetEtiquetas">
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de etiquetas</h3>
            <div class="card-tools mb-3">
                <button @click="showModal('crear-etiqueta')" class="btn btn-primary" id="crear-etiqueta">
                    Crear etiqueta
                </button>
            </div>
        </template>

        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="!loading" :class="['table', { 'expanded': etiquetas.data.length <= 3 }]">
                    <b-table hover :items="etiquetas.data" :fields="fields">
                        <template #cell(color)="{ item }">
                            <div 
                                style="display: flex; justify-content: center; align-items: center; height: 100%;"
                            >
                                <div 
                                    :style="{ backgroundColor: item.color, width: '30px', height: '30px', borderRadius: '4px', border: '1px solid #ddd' }"
                                >
                                </div>
                            </div>
                        </template>
                        <template #cell(opciones)="{ item, index }">
                            <OpcionesDropdownTableComponent 
                                :lastIndex="etiquetas.data.length > 3 && index >= etiquetas.data.length - 2"
                                v-bind:options="[
                                    { type: 'action', action:() => showModal('editar-' + item.id), label: 'Editar'},
                                    { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'},
                                ]"
                            />
                            <EditarEtiqueta
                                :etiqueta="item"
                                @close="closeModal()"
                                @update="editarEtiqueta"
                            />
                            <BorrarModalComponent
                                :name="'borrar-' + item.id"
                                :title="'Borrar etiqueta ' + item.name"
                                confirmButton="¿Está segur@ de borrar esta etiqueta?"
                                @close="() => closeModal()"
                                @confirm="() => borrar(item.id)"
                            />
                        </template>
                    </b-table>
                    <CrearEtiqueta
                        :etiqueta="{}"
                        @close="closeModal()"
                        @crear="crearEtiqueta"
                    />
                </div>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"
    import EditarEtiqueta from '@/modules/admin/etiquetas/modals/EditarEtiqueta.vue';
    import CrearEtiqueta from '@/modules/admin/etiquetas/modals/CrearEtiqueta.vue';

    export default {
        data() {
            return {
                loading: false,
                etiquetas: null,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                fields: [
                    { key: "name", label: "Nombre", class: 'text-center' },
                    { key: "color", label: "Color", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ]
            }
        },
        created() {
            this.getEtiquetas();
            this.debouncedGetEtiquetas = _.debounce(this.getEtiquetas, 500)
        },
        methods: {
            getEtiquetas() {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    teatro_id: this.teatro.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.etiquetas.index'), params).then(res => {
                    this.etiquetas = res.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            borrar(bloqueo_etiqueta_id) {
                this.loading = true;

                let params = {
                    teatro_id: this.teatro.id,
                    bloqueo_etiqueta_id,
                    filters: {}
                };
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.etiquetas.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getEtiquetas();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => this.loading = false);
            },
            editarEtiqueta(etiqueta) {
                this.loading = true;
                etiqueta.teatro_id = this.teatro.id;
                etiqueta.bloqueo_etiqueta_id = etiqueta.id;

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.etiquetas.editar'), etiqueta).then(res => {
                    this.$toast.success(res.data.message);
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => {
                    this.loading = false;
                    this.closeModal('edit-' + etiqueta.id);
                });
            },
            crearEtiqueta(etiqueta) {
                this.loading = true;
                etiqueta.teatro_id = this.teatro.id;

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.etiquetas.crear'), etiqueta).then(res => {
                    this.$toast.success(res.data.message);
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => {
                    this.loading = false;
                    this.closeModal('crear-etiqueta');
                });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, EditarEtiqueta, CrearEtiqueta, BorrarModalComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>